import { render, staticRenderFns } from "./commonHeader.vue?vue&type=template&id=af706690&"
import script from "./commonHeader.vue?vue&type=script&lang=js&"
export * from "./commonHeader.vue?vue&type=script&lang=js&"
import style0 from "./commonHeader.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports